export default "__VITE_ASSET__6f338891__"